import newRequestTypes, {
  request_type,
  selection_level,
} from "./newRequest.types";

const INITIAL_STATE = {
  preReq_time_show: false,

  request_type: request_type.NORMALL,

  destination_location: {
    destination_address_id: "",
    detail: "",
    lat: "",
    long: "",
    ostan: "",
    shahr: "",
  },
  other_destination_location: [],

  source_location: {
    destination_address_id: "",
    detail: "",
    lat: "",
    long: "",
    ostan: "",
    shahr: "",
  },

  cities: [],
  ciites_isLoading: false,

  vehicles: [],
  vehicles_isLoading: false,
  selected_vehicle: "",
  vehicle_requested_type: "",
  selected_province: "",
  selected_city: "",
  selection_level: selection_level.PROVINCE,

  selected_district: "",

  shownSuggestionPrice: "",
  suggestionPrice: "",
  suggestionPrice_isLoading: false,

  //
  loadTypes: [],
  loadTypes_isLoading: false,
  selected_loadType: "",

  bimeh: true,
  barnameh: true,

  load_value: "",

  desc_bargiry: "",
  desc_takhlieh: "",
  desc_load: "",

  weight: "",

  sizes_length: "",
  sizes_width: "",
  sizes_height: "",

  calenderBargiry_show: false,
  calenderTakhlieh_show: false,

  days_ahead: "",
  days_ahead_isLoading: "",

  bargiry_date: "",
  bargiry_time: "",

  takhlieh_date: "",
  takhlieh_time: "",
  takhlieh_timeTo: "",
  takhlieh_time_show: false,

  auctionList: "",
  auctionList_isLoading: false,

  selected_auction: "",

  is_two_way: false,
  payment_in_destination: false,
  vehicle_type: "",
  receiver_info: {
    phone: "",
    name: "",
  },
  loading_description: "",
  evacuation_description: "",
  packaging_type: "",
  postal_code: "",
  alert_notif_show: true,
};

const newReuqestReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case newRequestTypes.PAYMENT_IN_DESTINATION:
      return {
        ...state,
        payment_in_destination: !state.payment_in_destination,
      };
    case newRequestTypes.SET_PREREQ_IS_TWO_WAY:
      return {
        ...state,
        is_two_way: !state.is_two_way,
      };

    //
    case newRequestTypes.SET_PREREQ_TIME_SHOW:
      return {
        ...state,
        preReq_time_show: action.payload,
      };

    //
    case newRequestTypes.SET_REQUEST_TYPE:
      return {
        ...state,
        request_type: action.payload,
      };

    //
    case newRequestTypes.SET_SOURCE_LOCATION:
      return {
        ...state,
        source_location: action.payload,
      };

    case newRequestTypes.SET_DESTINATION_LOCATION:
      return {
        ...state,
        destination_location: action.payload,
      };

    case newRequestTypes.SET_OTHER_DESTINATIONS_LOCATION:
      return {
        ...state,
        other_destination_location: [
          ...state.other_destination_location,
          action.payload,
        ],
      };

    case newRequestTypes.UPDATE_OTHER_DESTINATIONS_LOCATION:
      const filtred_other_destination_location =
        state.other_destination_location.filter(
          (item) =>
            item.destination_address_id !==
            action.payload.destination_address_id
        );
      return {
        ...state,
        other_destination_location: filtred_other_destination_location,
      };

    // cities
    case newRequestTypes.FETCH_CITIES_START:
      return {
        ...state,
        ciites_isLoading: true,
      };
    case newRequestTypes.FETCH_CITIES_SUCCESS:
      return {
        ...state,
        cities: action.payload,
        ciites_isLoading: false,
      };
    //

    // selected cities
    case newRequestTypes.SET_SELECTION_LEVEL:
      return {
        ...state,
        selection_level: action.payload,
      };

    case newRequestTypes.SET_SELECTED_PROVINCE:
      return {
        ...state,
        selected_province: action.payload,
      };
    case newRequestTypes.SET_SELECTED_CITY:
      return {
        ...state,
        selected_city: action.payload,
      };

    case newRequestTypes.SET_SELECTED_DISTRICT:
      return {
        ...state,
        selected_district: action.payload,
      };

    //

    // vehicles
    case newRequestTypes.FETCH_VEHICLES_START:
      return {
        ...state,
        vehicles_isLoading: true,
      };
    case newRequestTypes.FETCH_VEHICLES_SUCCESS:
      return {
        ...state,
        vehicles: action.payload,
        vehicles_isLoading: false,
      };

    case newRequestTypes.SET_SELECTED_VEHICLE:
      return {
        ...state,
        selected_vehicle: action.payload,
      };
    case newRequestTypes.SET_VEHICLE_REQUESTED_TYPE:
      return {
        ...state,
        vehicle_requested_type: action.payload,
      };
    //

    // price suggestion
    case newRequestTypes.FETCH_SUGGESTIONPRICE_START: {
      return {
        ...state,
        suggestionPrice_isLoading: true,
      };
    }
    case newRequestTypes.FETCH_SUGGESTIONPRICE_SUCCESS: {
      return {
        ...state,

        suggestionPrice: action.payload,
        suggestionPrice_isLoading: false,
      };
    }
    case newRequestTypes.SET_SHOWN_SUGGESTIONPRICE: {
      return {
        ...state,

        shownSuggestionPrice: action.payload,
      };
    }
    //

    // load types
    case newRequestTypes.FETCH_LOADTYPES_START: {
      return {
        ...state,
        loadTypes_isLoading: true,
      };
    }
    case newRequestTypes.FETCH_LOADTYPES_SUCCESS: {
      return {
        ...state,
        loadTypes: action.payload,
        loadTypes_isLoading: false,
      };
    }
    case newRequestTypes.SET_LOAD_TYPE: {
      // debugger;
      return {
        ...state,
        selected_loadType: action.payload,
      };
    }
    //

    // bimeh
    case newRequestTypes.SET_BIMEH: {
      return {
        ...state,
        bimeh: action.payload,
      };
    }
    //

    // barnameh
    case newRequestTypes.SET_BARNAMEH: {
      return {
        ...state,
        barnameh: action.payload,
      };
    }
    //

    // load value
    case newRequestTypes.SET_LOADVALEU: {
      return {
        ...state,
        load_value: action.payload,
      };
    }
    //

    //  desc
    case newRequestTypes.SET_DESC_BARGIRY: {
      return {
        ...state,
        desc_bargiry: action.payload,
      };
    }
    case newRequestTypes.SET_DESC_TAKHLIEH: {
      return {
        ...state,
        desc_takhlieh: action.payload,
      };
    }
    case newRequestTypes.SET_DESC_LOAD: {
      return {
        ...state,
        desc_load: action.payload,
      };
    }
    //

    // weight
    case newRequestTypes.SET_LOAD_WEIGHT: {
      return {
        ...state,
        weight: action.payload,
      };
    }
    //

    // sizes
    case newRequestTypes.SET_SIZE_LENGTH: {
      return {
        ...state,
        sizes_length: action.payload,
      };
    }
    case newRequestTypes.SET_SIZE_WIDTH: {
      return {
        ...state,
        sizes_width: action.payload,
      };
    }
    case newRequestTypes.SET_SIZE_HEIGHT: {
      return {
        ...state,
        sizes_height: action.payload,
      };
    }
    //

    // calender
    case newRequestTypes.SET_CALENDERBARGIRY_SHOW: {
      return {
        ...state,
        calenderBargiry_show: action.payload,
      };
    }
    case newRequestTypes.SET_CALENDERTAKHLIEH_SHOW: {
      return {
        ...state,
        calenderTakhlieh_show: action.payload,
      };
    }
    //

    // days ahead
    case newRequestTypes.FETCH_DAYSAHEAD_START: {
      return {
        ...state,
        days_ahead_isLoading: true,
      };
    }
    case newRequestTypes.FETCH_DAYSAHEAD_SUCCESS: {
      return {
        ...state,
        days_ahead: action.payload,
        days_ahead_isLoading: false,
      };
    }
    //

    // bargiry date
    case newRequestTypes.SET_BARGIRY_DATE: {
      return {
        ...state,
        bargiry_date: action.payload,
      };
    }
    case newRequestTypes.SET_BARGIRY_TIME: {
      return {
        ...state,
        bargiry_time: action.payload,
      };
    }
    //

    // takhlieh date
    case newRequestTypes.SET_TAKHLIEH_DATE: {
      return {
        ...state,
        takhlieh_date: action.payload,
      };
    }
    case newRequestTypes.SET_TAKHLIEH_TIME: {
      return {
        ...state,
        takhlieh_time: action.payload,
      };
    }
    case newRequestTypes.SET_TAKHLIEH_TIMETO: {
      return {
        ...state,
        takhlieh_timeTo: action.payload,
      };
    }
    case newRequestTypes.SET_TAKHLIEH_TIME_SHOW: {
      return {
        ...state,
        takhlieh_time_show: action.payload,
      };
    }
    //

    // auction
    case newRequestTypes.FETCH_AUCTIONLIST_START:
      return {
        ...state,
        auctionList_isLoading: true,
      };
    case newRequestTypes.FETCH_AUCTIONLIST_SUCCESS:
      return {
        ...state,
        auctionList: action.payload,
        auctionList_isLoading: false,
      };
    case newRequestTypes.FETCH_AUCTIONLIST:
      return {
        ...state,
        auctionList: action.payload,
      };
    case newRequestTypes.SET_AUCTION:
      return {
        ...state,
        selected_auction: action.payload,
      };
    //
    case newRequestTypes.SET_VEHICLE_TYPE:
      return {
        ...state,
        vehicle_type: action.payload,
      };
    case newRequestTypes.SET_RECEIVER_INFO:
      return {
        ...state,
        receiver_info: action.payload,
      };
    case newRequestTypes.SET_LOADING_DESCRIPTION:
      return {
        ...state,
        loading_description: action.payload,
      };
    case newRequestTypes.SET_EVACUATION_DESCRIPTION:
      return {
        ...state,
        evacuation_description: action.payload,
      };
    case newRequestTypes.SET_PACKAGING_TYPE:
      return {
        ...state,
        packaging_type: action.payload,
      };
    case newRequestTypes.SET_POSTAL_CODE:
      return {
        ...state,
        postal_code: action.payload,
      };
    case newRequestTypes.SET_ALERT_NOTIF_SHOW:
      return {
        ...state,
        alert_notif_show: action.payload,
      };

    default:
      return state;
  }
};

export default newReuqestReducer;
